(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("base"), require("core"), require("module-metro-tulip"), require("moment"), require("lodash"), require("XmSdk"));
	else if(typeof define === 'function' && define.amd)
		define(["base", "core", "module-metro-tulip", "moment", "lodash", "XmSdk"], factory);
	else if(typeof exports === 'object')
		exports["module-metro-common"] = factory(require("base"), require("core"), require("module-metro-tulip"), require("moment"), require("lodash"), require("XmSdk"));
	else
		root["module-metro-common"] = factory(root["base"], root["core"], root["module-metro-tulip"], root["moment"], root["lodash"], root["XmSdk"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_3__, __WEBPACK_EXTERNAL_MODULE_4__, __WEBPACK_EXTERNAL_MODULE_5__, __WEBPACK_EXTERNAL_MODULE_8__, __WEBPACK_EXTERNAL_MODULE_9__, __WEBPACK_EXTERNAL_MODULE_12__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1);


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {'use strict';

	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    'use strict';

	    module.name = 'module-metro-common';

	    var base = __webpack_require__(3);
	    var core = __webpack_require__(4);
	    var tulip = __webpack_require__(5);

	    var deps = [core.name, tulip.name];

	    module.exports = base.createModule(module.name, deps).service(__webpack_require__(6)).factory(__webpack_require__(7))

	    // date filters
	    .service(__webpack_require__(10)).service(__webpack_require__(11)).service(__webpack_require__(13)).provider(__webpack_require__(15)).provider(__webpack_require__(16)).provider(__webpack_require__(17)).provider(__webpack_require__(18)).constant(__webpack_require__(19));
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)(module)))

/***/ }),
/* 2 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 3 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_3__;

/***/ }),
/* 4 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_4__;

/***/ }),
/* 5 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_5__;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';

	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports) {
	    'use strict';

	    function UserPrivileges() {
	        return {
	            hasPrivilege: function hasPrivilege() {
	                return true;
	            }
	        };
	    }

	    exports.userPrivileges = UserPrivileges;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';

	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports) {
	    'use strict';

	    var moment = __webpack_require__(8);
	    var _ = __webpack_require__(9);
	    // @ngInject
	    exports.metroUtils = function ($window, metroMeta, metroContext) {
	        return {
	            /**
	             * Returns index and obj found by key in obj
	             * @param obj
	             * @param keyName
	             * @returns {{index: number, filteredObj: *}}
	             */
	            findObjByKeyName: function findObjByKeyName(obj, keyName) {
	                var index = -1;
	                obj.findIndex(function (e, i) {
	                    index = i;
	                    return e.key === keyName;
	                });

	                return { index: index, filteredObj: obj[index] };
	            },

	            print: function print() {
	                $window.print();
	            },

	            canPrint: function canPrint() {
	                return $window.print;
	            },

	            /**
	             * Retrieves all query params from the url and presents them as an object
	             * @returns {Object}
	             */
	            getQueryParams: function getQueryParams() {
	                // remove initial "?"
	                var search = window.location.search.substr(1);
	                var pairs = search.split('&');

	                // compose array of array pairs [[key, value], ...]
	                var pairsArrays = pairs.map(function (pair) {
	                    if (pair.indexOf("locked") == -1) {
	                        return pair.split('=');
	                    } else {
	                        return ["locked", "false"];
	                    }
	                });

	                // convert matrix to object
	                return _.zipObject(pairsArrays);
	            },
	            getTppToggle: function getTppToggle() {
	                var tpp = localStorage.getItem('TPP');
	                return tpp;
	            },
	            navigate: function navigate(url, preserveQueryParams) {
	                var baseUri = b$.portal.config.serverRoot + '/';
	                var search = '';
	                if (preserveQueryParams) {
	                    search = window.location.search;
	                }

	                window.location.href = baseUri + url + search;
	            },

	            findEnvironment: function findEnvironment() {
	                var environment = metroMeta.ENVIRONMENT.DEV.isDev;
	                var url = window.location.href;
	                if (url.indexOf(metroMeta.ENVIRONMENT.PROD.url) != -1) {
	                    environment = metroMeta.ENVIRONMENT.PROD.isProd;
	                } else if (url.indexOf(metroMeta.ENVIRONMENT.STAGING.url) != -1) {
	                    environment = metroMeta.ENVIRONMENT.STAGING.isStaging;
	                }
	                return environment;
	            },

	            checkAuthLevel: function checkAuthLevel() {
	                var authLvl = '0';
	                if (metroContext.hasAnyApprovalLevel()) {
	                    authLvl = '1';
	                } else if (metroContext.hasAnyVerificationLevel()) {
	                    authLvl = '2';
	                }
	                return authLvl;
	            },

	            isShadowNostroCurrency: function isShadowNostroCurrency(currency) {
	                var shadowNostroCurrencies = ["ILS", "INR", "KES"];
	                return shadowNostroCurrencies.indexOf(currency) > -1;
	            },

	            checkForTPlusOneCurrencyPair: function checkForTPlusOneCurrencyPair(debitCurrency, creditCurrency) {
	                var tPlusOnePairs = ['USD/CAD', 'CAD/USD'];
	                return tPlusOnePairs.indexOf(debitCurrency + '/' + creditCurrency) > -1;
	            },

	            convertMS: function convertMS(milliseconds) {
	                var hour, minute, seconds;
	                seconds = Math.floor(milliseconds / 1000);
	                minute = Math.floor(seconds / 60);
	                seconds = seconds % 60;
	                hour = Math.floor(minute / 60);
	                minute = minute % 60;
	                hour = hour % 24;
	                return {

	                    hour: hour,
	                    minute: minute
	                };
	            },

	            isCloseToCutOffTime: function isCloseToCutOffTime(timezone, cutOffTime) {

	                if (!cutOffTime || !timezone) return;

	                var closeToCutOffTime = false;

	                //Get the offset of timezone for local location
	                var zoneOffset = moment().utcOffset() / 60;
	                var offsetNumber = zoneOffset.toString();

	                // calculate the difference between current location and server location

	                var serverTimezoneDifference = timezone.slice(4, 6);
	                var difference = offsetNumber - serverTimezoneDifference;

	                //get the current location date

	                var d = new Date();
	                var n = d.getHours();
	                var min = d.getMinutes();

	                //add 2 digits to minutes
	                if (min < 10) {
	                    min = '0' + min;
	                } else {
	                    min = min + '';
	                }

	                // adapt current location time to the server cuttof time
	                var compareHours = n - difference;
	                var fullCompareHour = compareHours + ':' + min;

	                // calculate 5 min before cutOffTime

	                var cutOffTimeFormat = cutOffTime.split(':');
	                var cutOffTimeFormatMiliseconds = cutOffTimeFormat[0] * (60000 * 60) + cutOffTimeFormat[1] * 60000;
	                var cutOffTimeDifference = cutOffTimeFormatMiliseconds - 60000 * 5;
	                var startCutOffTimeWarning = this.convertMS(cutOffTimeDifference);
	                var timeToInformUser = startCutOffTimeWarning.hour + ":" + startCutOffTimeWarning.minute;

	                var actualTimeCompare = new Date("01/01/2000 " + fullCompareHour);
	                var timeCompare = new Date("01/01/2000 " + timeToInformUser);

	                if (actualTimeCompare >= timeCompare) {
	                    closeToCutOffTime = true;
	                } else {
	                    closeToCutOffTime = false;
	                }
	                return closeToCutOffTime;
	            },

	            isCutOffTimePassed: function isCutOffTimePassed(timezone, cutOffTime, date) {

	                if (!cutOffTime || !timezone) return;

	                //get the UK date

	                var milliseconds = date;

	                var dateServerObject = new Date(milliseconds);
	                var serverDate = moment(dateServerObject).format('DD/MM/YYYY');

	                //Get the offset of timezone for local location
	                // 

	                var zoneOffset = moment().utcOffset() / 60;

	                var offsetNumber = zoneOffset.toString();

	                // calculate the difference between current location and server location

	                var serverTimezoneDifference = timezone.slice(4, 6);
	                var difference = offsetNumber - serverTimezoneDifference;

	                //get the current location date

	                var d = new Date();
	                var formatDate = moment(d).format('DD/MM/YYYY');

	                var n = d.getHours();
	                var min = d.getMinutes();

	                //add 2 digits to minutes
	                if (min < 10) {
	                    min = '0' + min;
	                } else {
	                    min = min + '';
	                }

	                // adapt current location time to the server cuttof time
	                var compareHours = n - difference;
	                var fullCompareHour = compareHours + ':' + min;

	                // compare the time1(cutofftime) and time2(local time - difference of timezones)
	                var time1 = cutOffTime;
	                var time2 = fullCompareHour;

	                var time1Date = new Date("01/01/2000 " + time1);
	                var time2Date = new Date("01/01/2000 " + time2);

	                //it is a posibility to have different date between curent location and server location and we will compare that
	                if (formatDate > serverDate) {
	                    return true;
	                } else {
	                    return time1Date <= time2Date;
	                }
	            },

	            checkOOH: function checkOOH(timezone, isHolidayToday, rightNow) {
	                if (!isHolidayToday) {
	                    if (rightNow.getDay() === 5) {
	                        isHolidayToday = this.isCutOffTimePassed(timezone, '21:00');
	                    }
	                    if (rightNow.getDay() === 1) {
	                        isHolidayToday = !this.isCutOffTimePassed(timezone, '02:00');
	                    }
	                }
	                return isHolidayToday;
	            },

	            parseCurrencyFormat: function parseCurrencyFormat(amount) {
	                return parseFloat(amount.toString().replace(/[ ,]/g, '').trim());
	            },
	            getUKTime: function getUKTime() {
	                var now = new Date();
	                var formatter = new Intl.DateTimeFormat("en-GB", {
	                    timeZone: "Europe/London",
	                    hour: "numeric",
	                    minute: "numeric",
	                    second: "numeric",
	                    hour12: false
	                });
	                var parts = formatter.formatToParts(now);
	                var getHour = parts.find(function (part) {
	                    return part.type === "hour";
	                }).value.padStart(2, "0");
	                var getMinute = parts.find(function (part) {
	                    return part.type === 'minute';
	                }).value.padStart(2, "0");
	                return getHour + ":" + getMinute;
	            },
	            cutOffTimeMessages: function cutOffTimeMessages() {
	                return {
	                    passed: 'It’s too late for us to process this payment/transfer today.',
	                    notPassed: function notPassed(hour) {
	                        return 'You must send the payment by <b>' + moment(hour, ["HH.mm"]).format("hh:mm a") + ' (UK time)</b> for it to be processed today.';
	                    }
	                };
	            }
	        };
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 8 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_8__;

/***/ }),
/* 9 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_9__;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';

	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports) {
	    'use strict';

	    var moment = __webpack_require__(8);

	    /**
	     * @ngInject
	     */
	    function metDatesFormatter($filter) {

	        return {
	            /**
	             * Filter for converting Date to ISO date substring
	             * (Date)date<"2016-03-24T15:51:44.633Z"> -> (String)"2016-03-24"
	             */
	            metDateToISO: function metDateToISO(date) {
	                return $filter('date')(date, 'yyyy-MM-dd');
	            },
	            /**
	             * Filter for converting ISO timestamp "2016-03-24T15:51:44.633Z" to Date("2016-03-24")
	             */
	            metDateFromISO: function metDateFromISO(ISOdateTimestamp) {
	                return new Date(moment(ISOdateTimestamp.substring(0, 10)));
	            },
	            /**
	             * Filter for converting calendar Date format "24 Aug 2016" to Date("2016-03-24")
	             */
	            calendarDateFromISO: function calendarDateFromISO(ISOdateTimestamp) {
	                return new Date(moment(ISOdateTimestamp.substring(0, 11)));
	            }
	        };
	    }

	    /**
	     * Exports
	     */
	    exports.metDatesFormatter = metDatesFormatter;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';

	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports) {
	    'use strict';

	    var sdkinit = __webpack_require__(12);
	    // var sdkui = require('metro-module-sdkui');
	    var sdk = new sdkinit.XmSdk();

	    /**
	     * @ngInject
	     */
	    function metroTransmit(metroUiHandler, tulipProvider) {

	        return {
	            authenticate: function authenticate(csPrefsNumber, obj, containerElement) {
	                return new Promise(function (resolve, reject) {
	                    sdk.authenticate(csPrefsNumber, 'user_login_journey_phase2', obj, containerElement).then(function (response) {
	                        resolve(response);
	                    }).catch(function (err) {
	                        reject(err);
	                    });
	                });
	            },
	            invokePolicy: function invokePolicy(journey, obj, containerElement) {
	                return new Promise(function (resolve, reject) {
	                    sdk.invokePolicy(journey, obj, containerElement).then(function (response) {
	                        resolve(response);
	                    }).catch(function (err) {
	                        reject(err);
	                    });
	                });
	            },
	            invokeAnonymousPolicy: function invokeAnonymousPolicy(journey, obj, containerElement) {
	                return new Promise(function (resolve, reject) {
	                    sdk.invokeAnonymousPolicy(journey, obj, containerElement).then(function (response) {
	                        resolve(response);
	                    }).catch(function (err) {
	                        reject(err);
	                    });
	                });
	            },
	            setConnectionSettings: function setConnectionSettings(connection) {
	                sdk.setConnectionSettings(connection);
	                return this;
	            },
	            initialize: function initialize() {
	                sdk.initialize().then(function () {
	                    console.info("initialized successfully");
	                }).catch(function (err) {
	                    console.info("Error: " + err.getMessage());
	                });
	            },
	            setUiHandler: function setUiHandler(handler) {
	                sdk.setUiHandler(handler);
	                sdk.setLogLevel(5);
	            },
	            logout: function logout() {
	                sdk.logout().then(function () {}).catch(function () {});
	            },
	            logoutPromise: function logoutPromise() {
	                return new Promise(function (resolve, reject) {
	                    sdk.logout().then(function () {
	                        resolve(true);
	                    }).catch(function (err) {
	                        reject(err);
	                    });
	                });
	            },
	            reinitialize: function reinitialize() {
	                return sdk.logout().then(function () {
	                    this.initialize();
	                }.bind(this)).catch(function () {
	                    this.initialize();
	                }.bind(this));
	            },
	            formatMdoduleString: function formatMdoduleString(request) {
	                if (request.sub_flow_type1 == "password-update") {
	                    return "Change Password";
	                } else if (request.sub_flow_type1 == "user" && (request.customer_operation == "amend" || request.customer_operation == "change")) {
	                    return "Amend Users";
	                } else if (request.sub_flow_type1 == "user" && request.customer_operation == "create") {
	                    return "Create Users";
	                } else if (request.sub_flow_type1 == "mandates" && request.customer_operation == "create") {
	                    return "Create Mandate";
	                } else if (request.sub_flow_type1 == "mandates" && (request.customer_operation == "amend" || request.customer_operation == "change")) {
	                    return "Amend Mandate";
	                } else if (request.sub_flow_type1 == "access_groups" && request.customer_operation == "create") {
	                    return "Create Access Group";
	                } else if (request.sub_flow_type1 == "access_groups" && (request.customer_operation == "amend" || request.customer_operation == "change")) {
	                    return "Amend Access Group";
	                } else if (request.sub_flow_type1 == "account_groups" && request.customer_operation == "create") {
	                    return "Create Account Group";
	                } else if (request.sub_flow_type1 == "account_groups" && (request.customer_operation == "amend" || request.customer_operation == "change")) {
	                    return "Amend Account Group";
	                } else if (request.sub_flow_type1 == "beneficiary" && request.customer_operation == "create") {
	                    return "Setup New Trusted Beneficiary";
	                } else if (request.sub_flow_type1 == "beneficiary" && (request.customer_operation == "edit" || request.customer_operation == "amend" || request.customer_operation == "change")) {
	                    return "Amend Trusted Beneficiary";
	                } else if (request.isPA == true && request.customer_operation == "approve") {
	                    return "Authenticating online payments";
	                } else if (request.isPA == false && request.customer_operation == "approve") {
	                    return "Authenticating your card";
	                }
	            },
	            widgetTransmitSetup: function widgetTransmitSetup() {
	                var scaEnable = false;
	                this.setUiHandler(metroUiHandler.CustomUIHandler);
	                return tulipProvider.getConfigData().then(function (response) {
	                    if (response.data && response.data.isScaPaymentEnabled) {
	                        var configData = response.data;
	                        scaEnable = true;
	                        var endpoint = configData.scaUrl;
	                        var appID = configData.appId;
	                        var doubleEncryption = configData.doubleEncryptionEnabled;
	                        var connectionSettings = void 0;
	                        if (doubleEncryption == "N") {
	                            connectionSettings = com.ts.mobile.sdk.SDKConnectionSettings.create(endpoint, appID);
	                        } else {
	                            connectionSettings = com.ts.mobile.sdk.SDKConnectionSettings.createWithCryptoMode(endpoint, appID, null, null, com.ts.mobile.sdk.ConnectionCryptoMode.Credentials);
	                        }
	                        this.setConnectionSettings(connectionSettings).initialize();
	                    } else {
	                        scaEnable = false;
	                    }
	                    return scaEnable;
	                }.bind(this), function (error) {
	                    return false;
	                });
	            },
	            widgetTransmitSetupBulk: function widgetTransmitSetupBulk() {
	                var scaEnable = false;
	                this.setUiHandler(metroUiHandler.CustomUIHandler);
	                return tulipProvider.getConfigData().then(function (response) {
	                    if (response.data && response.data.isScaPaymentEnabled) {
	                        var configData = response.data;
	                        scaEnable = true;
	                        var endpoint = configData.scaUrl;
	                        var appID = configData.appId;
	                        var doubleEncryption = configData.doubleEncryptionEnabled;
	                        var connectionSettings = void 0;
	                        if (doubleEncryption == "N") {
	                            connectionSettings = com.ts.mobile.sdk.SDKConnectionSettings.create(endpoint, appID);
	                        } else {
	                            connectionSettings = com.ts.mobile.sdk.SDKConnectionSettings.createWithCryptoMode(endpoint, appID, null, null, com.ts.mobile.sdk.ConnectionCryptoMode.Credentials);
	                        }
	                        this.setConnectionSettings(connectionSettings).initialize();
	                    } else {
	                        scaEnable = false;
	                    }
	                    return {
	                        scaEnable: scaEnable,
	                        fetchBenWaitTime: configData.fetchBenWaitTime,
	                        benAccRepetitionLeft: configData.benAccRepetitionLeft
	                    };
	                }.bind(this), function (error) {
	                    return false;
	                });
	            },
	            handleError: function handleError(error) {
	                var messages = [];
	                if (error === 'incorrect') {
	                    messages = [{ category: "payments", itemRef: null, responseCode: "LOGIN_INCORRECT", level: "error", detail: "Something's not quite right. Please check that your details are correct and try again. If you get your details wrong too many times, we will lock your account to keep it safe.", message: "Error: ", icon: "close", show: true, showDetail: true }];
	                }
	                if (error === 'generic') {
	                    messages = [{ category: "payments", itemRef: null, responseCode: "LOGIN_GENERIC", level: "error", detail: "Something went wrong, please try again later", message: "Error: ", icon: "close", show: true, showDetail: true }];
	                }
	                if (error === 'oneattemptleft') {
	                    messages = [{ category: "payments", itemRef: null, responseCode: "LOGIN_ONE_ATTEMPT_LEFT", level: "error", detail: "Some of the details you entered aren’t quite right. Please try again.You have 1 attempt left before we lock your account to keep it safe.", message: "Error: ", icon: "close", show: true, showDetail: true }];
	                }
	                if (error === 'oldpwd') {
	                    messages = [{ category: "payments", itemRef: null, responseCode: "OLD_PASSWORD_CRITERIA", level: "error", detail: "Password is the same as one of a previous", message: "Error: ", icon: "close", show: true, showDetail: true }];
	                }
	                if (error === 'passwordconstrainerror') {
	                    messages = [{ category: "passwordconstrainerror", itemRef: null, responseCode: "PASSWORD_CONSTRAIN", level: "error", detail: "Sorry – that password doesn’t meet our password criteria, please pick a different one.", message: "Error: ", icon: "close", show: true, showDetail: true }];
	                }
	                if (error === 'blockedprocess') {
	                    messages = [{ category: "payments", itemRef: null, responseCode: "SCACHK_PROCESS", level: "error", detail: "Unfortunately we cannot process your request right now. Please try again later or call us on 0345 08 08 500", message: "Error: ", icon: "close", show: true, showDetail: true }];
	                }
	                if (error === 'login_failure_locked_out') {
	                    messages = { "errors": [{ "title": "LOGIN_FAILURE_LOCKED_OUT", "show": true, "showDetail": false, "level": "error", "icon": "close", "id": "LOGIN_FAILURE_LOCKED_OUT", "category": "security" }] };
	                }
	                if (error === 'login_transmit_failure') {
	                    messages = { "errors": [{ "title": "LOGIN_TRANSMIT_FAILURE", "show": true, "showDetail": false, "messages": "<p>Unfortunately there is a problem, please try again. If it continues, please call us on 0345 08 08 500 and we’ll help you.</p>", "level": "error", "icon": "close", "id": "LOGIN_TRANSMIT_FAILURE", "category": "security" }] };
	                }
	                if (error === 'approvalunselected') {
	                    messages = [{ category: "approvalunselected", itemRef: null, responseCode: "APPROVAL_UNSELECTED", level: "error", detail: "Please select an option for each request shown.", message: "", icon: "close", show: true, showDetail: true, inlineMesssage: 'You must select approve or decline to continue' }];
	                }
	                if (error === 'cardsgeneric_PA') {
	                    messages = [{ category: "cards", itemRef: null, responseCode: "CARD_GENERIC", level: "error", detail: "Sorry, something's gone wrong please try again. If this keep happening, please call us on 0345 08 08 500", message: "", icon: "close", show: true, showDetail: true, inlineMesssage: "This payment decision couldn't be sent, please try again" }];
	                }
	                if (error === 'cardsgeneric_NPA') {
	                    messages = [{ category: "cards", itemRef: null, responseCode: "CARD_GENERIC", level: "error", detail: "Sorry, something's gone wrong please try again. If this keep happening, please call us on 0345 08 08 500", message: "", icon: "close", show: true, showDetail: true, inlineMesssage: "This card authorisation couldn't be sent, please try again." }];
	                }
	                if (error === 'tysys_failure_PA') {
	                    messages = [{ category: "cards", itemRef: null, responseCode: "tysys_failure", level: "error", detail: "", message: "Sorry, something's gone wrong please try again.<br> If this keeps happening, please call us on 0345 08 08 500", icon: "close", show: true, showDetail: true, inlineMesssage: "Something's gone wrong with this payment, please return to the seller and try again." }];
	                }
	                if (error === 'tysys_failure_NPA') {
	                    messages = [{ category: "cards", itemRef: null, responseCode: "tysys_failure", level: "error", detail: "", message: "Sorry, something's gone wrong please try again.<br> If this keeps happening, please call us on 0345 08 08 500", icon: "close", show: true, showDetail: true, inlineMesssage: "Something's gone wrong with this request, please return to the seller and try again." }];
	                }
	                if (error === 'cardsgenericmultiple') {
	                    messages = [{ category: "cardsgenericmultiple", itemRef: null, responseCode: "CARDS_AUTHORISE", level: "error", detail: "Sorry, something's gone wrong please try again. If the problem persists please call us on 0345 08 08 500", message: "", icon: "close", show: true, showDetail: true, inlineMesssage: "This card authorisation couldn't be sent, please try again" }];
	                }
	                if (error === 'transmit_high_risk') {
	                    messages = [{ category: "TRANSMIT_HIGH_RISK", itemRef: null, responseCode: "TRANSMIT_HIGH_RISK", level: "error", detail: "Sorry, something has gone wrong.", message: "", icon: "close", show: true, showDetail: true, inlineMesssage: "" }];
	                }
	                return messages;
	            },

	            initiateTransmitCards: function initiateTransmitCards() {
	                var scaCardsEnabled = false;
	                this.setUiHandler(metroUiHandler.CustomUIHandler);
	                return tulipProvider.getConfigData().then(function (response) {
	                    if (response.data && response.data.isScaCardsEnabled) {
	                        var configData = response.data;
	                        scaCardsEnabled = true;
	                        var endpoint = configData.scaUrl;
	                        var appID = configData.appId;
	                        var doubleEncryption = configData.doubleEncryptionEnabled;
	                        var connectionSettings = void 0;
	                        if (doubleEncryption == "N") {
	                            connectionSettings = com.ts.mobile.sdk.SDKConnectionSettings.create(endpoint, appID);
	                        } else {
	                            connectionSettings = com.ts.mobile.sdk.SDKConnectionSettings.createWithCryptoMode(endpoint, appID, null, null, com.ts.mobile.sdk.ConnectionCryptoMode.Credentials);
	                        }
	                        this.setConnectionSettings(connectionSettings).initialize();
	                    } else {
	                        scaCardsEnabled = false;
	                    }
	                    return scaCardsEnabled;
	                }.bind(this), function (error) {
	                    return false;
	                });
	            }
	        };
	    }

	    /**
	     * Exports
	     */
	    exports.metroTransmit = metroTransmit;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 12 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_12__;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';

	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports) {
	    'use strict';

	    var sdkinit = __webpack_require__(12);
	    var waitableTicket = __webpack_require__(14);
	    var sdk = new sdkinit.XmSdk();

	    var journey = '';
	    var subModuleJourney = '';
	    var updatedPassword = "";
	    var promises = {};
	    var jsonData = {};
	    var self = this;

	    /**
	     * @ngInject
	     */

	    /* function CustomUIHandler() {
	        sdkinit.XmUIHandler.call(this);
	    }  */
	    function metroUiHandler(lpCoreBus) {

	        //############# Start BaseAuthenticatorSession prototype

	        function BaseAuthenticatorSession(title, username, common) {
	            this.supportsInlineError = false;
	            this.title = title;
	            this.username = username;
	            this.common = common;
	        }

	        BaseAuthenticatorSession.prototype.baseConstructor = function (title, username, common) {
	            this.supportsInlineError = false;
	            this.title = title;
	            this.username = username;
	            this.common = common;
	        };
	        BaseAuthenticatorSession.prototype.startSession = function (description, mode, actionContext, clientContext) {
	            this.description = description;
	            this.mode = mode;
	            this.actionContext = actionContext;
	            this.clientContext = clientContext;
	            this.common.log('Starting session; session mode: [' + this.mode + '], authenticator: [' + this.title + ']');
	        };
	        BaseAuthenticatorSession.prototype.changeSessionModeToRegistrationAfterExpiration = function () {
	            this.common.log('Changing session mode to registration after expiration; authenticator: [' + this.title + ']');
	            this.mode = com.ts.mobile.sdk.AuthenticatorSessionMode.Registration;
	            this.authError = null;
	        };
	        BaseAuthenticatorSession.prototype.promiseRecoveryForError = function (error, validRecoveries, defaultRecovery) {
	            this.common.log('Starting error recovery; session mode: [' + this.mode + '], authenticator: [' + this.title + '], error: [' + error + ']');
	            if (this.supportsInlineError && defaultRecovery === com.ts.mobile.sdk.AuthenticationErrorRecovery.RetryAuthenticator) {
	                this.authError = error;
	                return Promise.resolve(defaultRecovery);
	            } else if (defaultRecovery === com.ts.mobile.sdk.AuthenticationErrorRecovery.Fail) {
	                return Promise.resolve(defaultRecovery);
	            }
	            return this.common.promiseRecoveryForError(error, validRecoveries, defaultRecovery, this.clientContext);
	        };
	        BaseAuthenticatorSession.prototype.endSession = function () {
	            this.common.log('Ending session; session mode: [' + this.mode + '], authenticator: [' + this.title + ']');
	        };
	        BaseAuthenticatorSession.prototype.promiseInput = function () {
	            //this.common.setAriaBusy(this.clientContext);
	            var promise = void 0;
	            switch (this.mode) {
	                case com.ts.mobile.sdk.AuthenticatorSessionMode.Authentication:
	                    this.common.log('Fetching authentication input; authenticator: [' + this.title + ']');
	                    //this.common.unsetAriaBusy(this.clientContext);
	                    promise = this.promiseAuthInput();
	                    break;
	                case com.ts.mobile.sdk.AuthenticatorSessionMode.Registration:
	                    this.common.log('Fetching registration input; authenticator: [' + this.title + ']');
	                    //this.common.unsetAriaBusy(this.clientContext);
	                    promise = this.promiseRegInput();
	                    break;
	            }
	            return promise.then(function (input) {
	                //this.common.clearContainer(this.clientContext);
	                return input;
	            });
	        };

	        //############# End BaseAuthenticatorSession prototype


	        function CustomUIHandler() {
	            //   sdkinit.XmUIHandler.call(this);
	        }
	        console.log(sdkinit);
	        //CustomUIHandler.prototype = Object.create(sdkinit.XmUIHandler.prototype);
	        CustomUIHandler.prototype.constuctor = CustomUIHandler;

	        CustomUIHandler.prototype.selectAuthenticatorFallbackAction = function (validOptions, fallbackAuthenticator, session, actionContext, clientContext) {
	            setKeyValue("softokenError", true);
	            return new Promise(function (resolve, reject) {
	                resolve({ abortSelection: true });
	            });
	        };

	        CustomUIHandler.prototype.createFormSession = function (formId, payload) {
	            return {
	                getContainer: function getContainer(clientContext) {
	                    return xmui.XmUIHandler.getContainer(clientContext);
	                },
	                startSession: function startSession(clientContext, actionContext) {
	                    this.actionContext = actionContext;
	                    this.clientContext = clientContext;
	                },
	                promiseFormInput: function promiseFormInput() {
	                    if (formId) {
	                        lpCoreBus.publish(journey + '.uiHandler.' + formId, payload);
	                        return new Promise(function (resolve, reject) {
	                            promises[journey] = {
	                                "resolve": resolve,
	                                "reject": reject
	                            };
	                        });
	                    }
	                },
	                onContinue: function onContinue() {},
	                onError: function onError(payload) {
	                    console.log(payload);
	                },
	                endSession: function endSession(payload) {
	                    console.log(payload);
	                }
	            };
	        };

	        CustomUIHandler.prototype.processJsonData = function (jsonData) {
	            //console.log("---> processJsonData", jsonData.promote_mobile_authenticator.promote_mobile_authenticator)
	            if (jsonData.login_cross_session_id) {
	                setKeyValue("login_cross_session_id", jsonData.login_cross_session_id);
	                //jsonData.login_cross_session_id  = jsonData.login_cross_session_id
	            }
	            if (jsonData.sca_soft_token_enabled) {
	                lpCoreBus.publish('scaEnabled', true);
	            } else {
	                lpCoreBus.publish('scaEnabled', false);
	            }

	            if (jsonData.is_fake_journey) {
	                setKeyValue("isFirstFactorAuthenticationFailed", true);
	                setKeyValue("softokenErrorMessage", jsonData.lock_rule_response);
	            }

	            return Promise.resolve(com.ts.mobile.sdk.JsonDataProcessingResult.create(true));
	        };

	        CustomUIHandler.prototype.createTicketWaitSession = function (actionContext, clientContext) {
	            return new waitableTicket.TicketWaitSession(this.common);
	        };

	        CustomUIHandler.prototype.handlePolicyRejection = function handlePolicyRejection(title, text, buttonText, failureData, actionContext, clientContext) {
	            console.log('handlePolicyRejection requested.');
	            return Promise.resolve(com.ts.mobile.sdk.ConfirmationInput.create(-1)); // -1 for continue and 0 for reject
	        };

	        CustomUIHandler.prototype.handlePolicyRedirect = function handlePolicyRedirect(redirectType, policyId, userId, additionalParameters, clientContext) {
	            console.log('Policy redirection requested. redirecting to policy: [' + policyId + '] with additionalParameters: [' + additionalParameters + ']');
	            return Promise.resolve(com.ts.mobile.sdk.RedirectInput.create(com.ts.mobile.sdk.RedirectResponseType.RedirectToPolicy));
	        };
	        CustomUIHandler.prototype.controlFlowCancelled = function controlFlowCancelled(clientContext) {
	            console.log("Control flow cancelled");
	            // this.common.clearContainer(clientContext);
	        };

	        CustomUIHandler.prototype.shouldIncludeDisabledAuthenticatorsInMenu = function shouldIncludeDisabledAuthenticatorsInMenu(actionContext, clientContext) {
	            console.log('shouldIncludeDisabledAuthenticatorsInMenu');
	            return true;
	        };

	        waitableTicket.TicketWaitSession.prototype.setWaitingTicket = function (ticketWaitInfo) {
	            if (!jsonData.login_cross_session_id) {
	                lpCoreBus.publish('loadTickeUi', ticketWaitInfo);
	            }
	        };

	        waitableTicket.TicketWaitSession.prototype.startSession = function (actionContext, clientContext) {
	            console.log(actionContext);
	        };

	        CustomUIHandler.prototype.selectAuthenticator = function (options, actionContext, clientContext) {
	            return new Promise(function (resolve, reject) {
	                if (options && options.length > 0) {
	                    var option;
	                    options.forEach(function (op) {
	                        var authenticator = op.getAuthenticator();
	                        if (authenticator["_authenticatorId"] == "totp") {
	                            option = op;
	                        }
	                    });

	                    if (!option) {
	                        if (getKeyValue("isFirstFactorAuthenticationFailed")) {
	                            jsonData.softokenErrorMessage.biomatricDisabled = true;
	                            resolve(com.ts.mobile.sdk.AuthenticatorSelectionResult.createAbortRequest());
	                        } else {
	                            lpCoreBus.publish('contentSoftotokeUIHandler', true);
	                        }
	                    } else {
	                        var authenticator = option.getAuthenticator();
	                        resolve(com.ts.mobile.sdk.AuthenticatorSelectionResult.createSelectionRequest(authenticator));
	                    }
	                }
	            });
	        };

	        var MobileApproveAuthenticationState;
	        (function (MobileApproveAuthenticationState) {
	            MobileApproveAuthenticationState[MobileApproveAuthenticationState["TargetSelection"] = 0] = "TargetSelection";
	            MobileApproveAuthenticationState[MobileApproveAuthenticationState["PollingRequested"] = 1] = "PollingRequested";
	            MobileApproveAuthenticationState[MobileApproveAuthenticationState["PollingStarted"] = 2] = "PollingStarted";
	        })(MobileApproveAuthenticationState || (MobileApproveAuthenticationState = {}));

	        CustomUIHandler.prototype.createMobileApproveAuthSession = function (title, username, instructions) {

	            function MobileApproveAuthenticatorSession() {}
	            MobileApproveAuthenticatorSession.prototype = Object.create(BaseAuthenticatorSession.prototype);

	            MobileApproveAuthenticatorSession.prototype.constructor = function (title, username, instructions) {
	                var common = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : console;


	                console.log("++++++++++++++++++++MobileApproveAuthenticatorSession");
	                this.state = MobileApproveAuthenticationState.TargetSelection;
	                this.pollingIntervalMillis = 3000;
	                this.instructions = instructions;

	                this.baseConstructor(title, username, common);

	                return this;
	            };

	            MobileApproveAuthenticatorSession.prototype.setPollingIntervalInMillis = function (millis) {
	                this.pollingIntervalMillis = millis;
	            };
	            MobileApproveAuthenticatorSession.prototype.setCreatedApprovalInfo = function (targets, otp) {
	                if (targets != null) {
	                    this.createdForTargets = targets;
	                    this.otp = otp;
	                    this.state = MobileApproveAuthenticationState.PollingRequested;
	                } else {
	                    this.createdForTargets = null;
	                    this.otp = null;
	                    this.state = MobileApproveAuthenticationState.TargetSelection;
	                    clearTimeout(this.pollingTimer);
	                    this.hidePendingUi();
	                }
	            };
	            MobileApproveAuthenticatorSession.prototype.setAvailableTargets = function (targets) {
	                this.availableTargets = targets;
	            };
	            MobileApproveAuthenticatorSession.prototype.endSession = function () {
	                clearTimeout(this.pollingTimer);
	                // this.common.clearContainer(this.clientContext);
	            };
	            MobileApproveAuthenticatorSession.prototype.promiseInput = function () {
	                var _this = this;

	                switch (this.mode) {
	                    case com.ts.mobile.sdk.AuthenticatorSessionMode.Authentication:
	                        //this.common.setAriaBusy(this.clientContext);
	                        this.common.log("Fetching Mobile Approve authentication input;");
	                        switch (this.state) {
	                            case MobileApproveAuthenticationState.TargetSelection:
	                                return this.promiseTargetSelectionInput();
	                            case MobileApproveAuthenticationState.PollingRequested:
	                                this.state = MobileApproveAuthenticationState.PollingStarted;
	                                this.promisePendingUI().then(function (input) {
	                                    clearTimeout(_this.pollingTimer);
	                                    _this.hidePendingUi();
	                                    if (_this.currentPollingResolver) {
	                                        _this.currentPollingResolver(input);
	                                        _this.currentPollingResolver = null;
	                                    } else {
	                                        _this.pendingCancelRequest = input;
	                                    }
	                                });
	                                return this.startPolling();
	                            case MobileApproveAuthenticationState.PollingStarted:
	                                return this.startPolling();
	                            default:
	                                return Promise.reject("Illegal state");
	                        }
	                    case com.ts.mobile.sdk.AuthenticatorSessionMode.Registration:
	                        throw new Error("Method not implemented.");
	                }
	            };
	            MobileApproveAuthenticatorSession.prototype.promiseTargetSelectionInput = function () {
	                var _this2 = this;

	                var authMobileAuthSelectDeviceForm = $('<div class="xmuiCore xmuiForm xmuiMobileAuthSelectDeviceForm">\
	                <div class="xmuiPrompt" data-xmui-customstringtext="mobileAuthDeviceSelection.selectDevices"/>\
	                <div class="xmuiFullHeightContentBelowPrompt xmuiAuthMobileDeviceSelection">\
	                    <div class="xmuiAuthMobileDeviceSelectionList"></div>\
	                    <div style="align-items: center;">\
	                        <button class="xmuiLoginButton" type="submit" data-xmui-customstringtext="mobileAuthDeviceSelection.select"/>\
	                    </div>\
	                </div>\
	            </div>');
	                var authMobileDeviceSelectionList = authMobileAuthSelectDeviceForm.find(".xmuiAuthMobileDeviceSelectionList");
	                var selectButton = authMobileAuthSelectDeviceForm.find(".xmuiLoginButton");
	                var selectionPrompt = authMobileAuthSelectDeviceForm.find(".xmuiPrompt");
	                this.common.appendElement(authMobileAuthSelectDeviceForm, this.clientContext);
	                return new Promise(function (resolve, reject) {
	                    _this2.availableTargets.forEach(function (target) {
	                        var description = target.getDescription();
	                        var inputElement = $("<input/>").attr({
	                            id: "xmui_device_" + description,
	                            name: "xmui_device_" + description,
	                            type: 'checkbox'
	                        }).data('xmui_device_id', target);
	                        var labelElement = $("<label/>").attr("htmlFor", "xmui_device_" + description).text(description).css("font-size", "10pt");
	                        authMobileDeviceSelectionList.append(inputElement).append(labelElement).append($("<br/>"));
	                    });
	                    selectButton.click(function () {
	                        var selectedTargets = [],
	                            checkedCheckboxes = authMobileAuthSelectDeviceForm.find('input:checkbox:checked');
	                        checkedCheckboxes.each(function (index, element) {
	                            selectedTargets.push($(element).data('xmui_device_id'));
	                        });
	                        if (selectedTargets.length <= 0) {
	                            selectionPrompt.text(_this2.common.resolveString("mobileApprove.deviceSelection.noneError"));
	                            selectionPrompt.addClass("xmuiPromptError");
	                            selectionPrompt.attr("role", "alert").attr("aria-label", _this2.common.resolveString("aria.noDeviceSelected"));
	                        } else {
	                            authMobileAuthSelectDeviceForm.fadeOut(function () {
	                                var input = com.ts.mobile.sdk.TargetBasedAuthenticatorInput.createTargetsSelectionRequest(selectedTargets);
	                                resolve(com.ts.mobile.sdk.InputOrControlResponse.createInputResponse(input));
	                            });
	                        }
	                    });
	                    _this2.common.prependPageHeader(authMobileAuthSelectDeviceForm, _this2.title, resolve);
	                }).then(function (input) {
	                    //this.common.unsetAriaBusy(this.clientContext);
	                    // this.common.clearContainer(this.clientContext);
	                    return input;
	                });
	            };
	            MobileApproveAuthenticatorSession.prototype.promisePendingUI = function () {
	                return new Promise(function (resolve, reject) {
	                    var formName = subModuleJourney == "password-update" ? "COB_SCA_ST_PW_form" : "COB_SCA_ST_form";
	                    lpCoreBus.publish('user_hrp_journey.uiHandler.' + formName, { "softToken": true, "promiseResolve": resolve, "endSession": MobileApproveAuthenticatorSession.prototype.endSession });
	                });
	            };
	            MobileApproveAuthenticatorSession.prototype.updateOtp = function () {
	                if (this.otp) {
	                    var otpFormatType = this.otp.getFormat().getType();
	                    switch (otpFormatType) {
	                        case com.ts.mobile.sdk.OtpFormatType.Numeric:
	                            var text = $(".xmuiMobileAuthForm").find(".xmuiOtpText");
	                            text.text(this.otp.getValue());
	                            text.show();
	                            break;
	                        case com.ts.mobile.sdk.OtpFormatType.QrCode:
	                            var img = $(".xmuiMobileAuthForm").find(".xmuiOtpImg");
	                            img.attr("src", "data:image/jpeg;base64," + this.otp.getValue());
	                            img.show();
	                            break;
	                        default:
	                            this.common.log("Unsupported otp format");
	                            throw new Error("Unsupported otp format");
	                    }
	                }
	            };
	            MobileApproveAuthenticatorSession.prototype.hidePendingUi = function () {
	                //this.common.unsetAriaBusy(this.clientContext);
	                $(".xmuiMobileAuthForm").hide();
	            };
	            MobileApproveAuthenticatorSession.prototype.promiseRecoveryBaseForError = function (error, validRecoveries, defaultRecovery) {
	                console.log(error);
	                this.common.log('Starting error recovery; session mode: [' + this.mode + '], authenticator: [' + this.title + '], error: [' + error + ']');
	                if (this.supportsInlineError && defaultRecovery === com.ts.mobile.sdk.AuthenticationErrorRecovery.RetryAuthenticator) {
	                    this.authError = error;
	                    return Promise.resolve(defaultRecovery);
	                } else if (defaultRecovery === com.ts.mobile.sdk.AuthenticationErrorRecovery.Fail) {
	                    return Promise.resolve(defaultRecovery);
	                }
	                return this.common.promiseRecoveryForError(error, validRecoveries, defaultRecovery, this.clientContext);
	            };
	            MobileApproveAuthenticatorSession.prototype.promiseRecoveryForError = function (error, validRecoveries, defaultRecovery) {
	                return new Promise(function (resolve, reject) {
	                    if (error.getErrorCode() == com.ts.mobile.sdk.AuthenticationErrorCode.ApprovalExpired) {
	                        resolve(com.ts.mobile.sdk.AuthenticationErrorRecovery.SelectAuthenticator);
	                    } else if (error.getErrorCode() == com.ts.mobile.sdk.AuthenticationErrorCode.ApprovalDenied) {
	                        lpCoreBus.publish('softoken-declined');
	                        resolve({ abortSelection: true });
	                    }
	                });
	            };
	            MobileApproveAuthenticatorSession.prototype.startPolling = function () {
	                var _this3 = this;

	                return new Promise(function (resolve, reject) {
	                    _this3.updateOtp();
	                    _this3.pollingTimer = setTimeout(function () {
	                        _this3.currentPollingResolver = null;
	                        if (_this3.pendingCancelRequest) {
	                            resolve(_this3.pendingCancelRequest);
	                        } else {
	                            resolve(com.ts.mobile.sdk.InputOrControlResponse.createInputResponse(com.ts.mobile.sdk.TargetBasedAuthenticatorInput.createAuthenticatorInput(com.ts.mobile.sdk.MobileApproveInputRequestPolling.createRequestPollingInput())));
	                        }
	                    }, _this3.pollingIntervalMillis);
	                    _this3.currentPollingResolver = resolve;
	                });
	            };
	            MobileApproveAuthenticatorSession.prototype.promiseAuthInput = function () {
	                throw new Error("Method not implemented");
	            };
	            MobileApproveAuthenticatorSession.prototype.promiseRegInput = function () {
	                throw new Error("Method not implemented");
	            };

	            MobileApproveAuthenticatorSession.prototype.promiseCancelAction = function (options, clientContext) {
	                var controlRequest = com.ts.mobile.sdk.ControlRequest.create(com.ts.mobile.sdk.ControlRequestType.ChangeMethod);
	                console.log(controlRequest.getRequestType());
	                return Promise.resolve(controlRequest);
	            };

	            return new MobileApproveAuthenticatorSession().constructor(title, username, instructions, this.common);
	        };

	        CustomUIHandler.prototype.controlOptionForCancellationRequestInSession = function (validOptions, session) {
	            return session.promiseCancelAction(validOptions, session.clientContext);
	        };

	        CustomUIHandler.prototype.createTotpAuthSession = function (title, username) {
	            function TotpAuthenticatorSession(title, username) {
	                var common = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : console;

	                this.title = title;
	                this.username = username;
	                this.common = common;
	            }

	            TotpAuthenticatorSession.prototype.setAvailableTargets = function (targets) {

	                this.availableTargets = targets;
	            };

	            TotpAuthenticatorSession.prototype.startSession = function (description, mode, actionContext, clientContext) {
	                this.description = description;
	                this.mode = mode;
	                this.actionContext = actionContext;
	                this.clientContext = clientContext;
	                this.common.log('Starting session; session mode: [' + this.mode + '], authenticator: [' + this.title + ']');
	            };

	            TotpAuthenticatorSession.prototype.promiseRecoveryBaseForError = function (error, validRecoveries, defaultRecovery) {

	                this.common.log('Starting error recovery; session mode: [' + this.mode + '], authenticator: [' + this.title + '], error: [' + error + ']');
	                if (this.supportsInlineError && defaultRecovery === com.ts.mobile.sdk.AuthenticationErrorRecovery.RetryAuthenticator) {
	                    console.log("promiseRecoveryBaseForError -> RetryAuthenticator", error);
	                    this.authError = error;
	                    return Promise.resolve(defaultRecovery);
	                } else if (defaultRecovery === com.ts.mobile.sdk.AuthenticationErrorRecovery.Fail) {
	                    console.log("promiseRecoveryBaseForError -> Fail", error);
	                    return Promise.resolve(defaultRecovery);
	                }
	                console.log("promiseRecoveryBaseForError -> ", defaultRecovery, error);
	                return this.common.promiseRecoveryForError(error, validRecoveries, defaultRecovery, this.clientContext);
	            };

	            TotpAuthenticatorSession.prototype.endSession = function () {
	                if (this.common) {
	                    this.common.log('Ending session; session mode: [' + this.mode + '], authenticator: [' + this.title + ']');
	                    clearTimeout(this.pollingTimer);
	                }
	            };

	            TotpAuthenticatorSession.prototype.changeSessionModeToRegistrationAfterExpiration = function () {
	                this.common.log('Changing session mode to registration after expiration; authenticator: [' + this.title + ']');
	                this.mode = com.ts.mobile.sdk.AuthenticatorSessionMode.Registration;
	                this.authError = null;
	            };

	            TotpAuthenticatorSession.prototype.promiseInput = function () {
	                // this.common.setAriaBusy(this.clientContext);
	                var promise = void 0;
	                switch (this.mode) {
	                    case com.ts.mobile.sdk.AuthenticatorSessionMode.Authentication:
	                        this.common.log('Fetching authentication input; authenticator: [' + this.title + ']');
	                        //this.common.unsetAriaBusy(this.clientContext);
	                        promise = this.promiseAuthInput();
	                        break;
	                    case com.ts.mobile.sdk.AuthenticatorSessionMode.Registration:
	                        this.common.log('Fetching registration input; authenticator: [' + this.title + ']');
	                        // this.common.unsetAriaBusy(this.clientContext);
	                        promise = this.promiseRegInput();
	                        break;
	                }
	                return promise.then(function (input) {
	                    //this.common.clearContainer(this.clientContext);
	                    return input;
	                });
	            };

	            TotpAuthenticatorSession.prototype.setTargetDevices = function (targets) {

	                this.targetDevices = targets;
	            };

	            TotpAuthenticatorSession.prototype.setChallenge = function (challenge) {

	                this.challenge = challenge;
	            };

	            TotpAuthenticatorSession.prototype.promiseAuthInput = function () {

	                if (this.availableTargets && !this.targetDevices) {
	                    return this.promiseTargetSelectionInput();
	                } else {
	                    return this.promiseCodeInput();
	                }
	            };

	            TotpAuthenticatorSession.prototype.promiseRecoveryForError = function (error, validRecoveries, defaultRecovery) {
	                console.log(error.getErrorCode(), com.ts.mobile.sdk.AuthenticationErrorCode.InvalidInput, "\n", validRecoveries, com.ts.mobile.sdk.AuthenticationErrorRecovery.RetryAuthenticator, "\n", defaultRecovery);

	                var errorAction = com.ts.mobile.sdk.AuthenticationErrorRecovery.Fail;

	                if (error.getErrorCode() == com.ts.mobile.sdk.AuthenticationErrorCode.InvalidInput && validRecoveries.indexOf(com.ts.mobile.sdk.AuthenticationErrorRecovery.RetryAuthenticator) >= 0) {

	                    //TODO: Show message for wrong TOTP and retry
	                    //$scope.totpInvalidInput = true;
	                    errorAction = com.ts.mobile.sdk.AuthenticationErrorRecovery.RetryAuthenticator;
	                }
	                return Promise.resolve(errorAction);
	            };

	            TotpAuthenticatorSession.prototype.promiseTargetSelectionInput = function () {
	                var _this4 = this;

	                var totpSelectDeviceForm = $('<div class="xmuiCore xmuiForm xmuiTotpSelectDeviceForm">\
	                        <div class="xmuiPrompt" data-xmui-customstringtext="totpDeviceSelection.selectDevices"/>\
	                        <div class="xmuiFullHeightContentBelowPrompt xmuiAuthMobileDeviceSelection">\
	                            <div class="xmuiTotpDeviceSelectionList"></div>\
	                            <div style="align-items: center;">\
	                                <button class="xmuiLoginButton" type="submit" data-xmui-customstringtext="mobileAuthDeviceSelection.select"/>\
	                            </div>\
	                        </div>\
	                    </div>');
	                var totpDeviceSelectionList = totpSelectDeviceForm.find(".xmuiTotpDeviceSelectionList");
	                var totpSelectDeviceFormSelectButton = totpSelectDeviceForm.find(".xmuiLoginButton");
	                var selectionPrompt = totpSelectDeviceForm.find(".xmuiPrompt");
	                this.common.appendElement(totpSelectDeviceForm, this.clientContext);
	                return new Promise(function (resolve, reject) {
	                    _this4.availableTargets.forEach(function (target) {
	                        var description = target.getDescription();
	                        var inputElement = $("<input/>").attr({
	                            id: "xmui_device_" + description,
	                            name: "xmui_device_" + description,
	                            type: 'checkbox'
	                        }).data('xmui_device_id', target);
	                        var labelElement = $("<label/>").attr("htmlFor", "xmui_device_" + description).text(description).css("font-size", "10pt");
	                        totpDeviceSelectionList.append(inputElement).append(labelElement).append($("<br/>"));
	                    });
	                    totpSelectDeviceFormSelectButton.click(function () {
	                        var selectedTargets = [],
	                            checkedCheckboxes = totpSelectDeviceForm.find('input:checkbox:checked');
	                        checkedCheckboxes.each(function (index, element) {
	                            selectedTargets.push($(element).data('xmui_device_id'));
	                        });
	                        if (selectedTargets.length <= 0) {
	                            selectionPrompt.text(_this4.common.resolveString("totp.deviceSelection.noneError"));
	                            selectionPrompt.addClass("xmuiPromptError");
	                            selectionPrompt.attr("role", "alert").attr("aria-label", _this4.common.resolveString("aria.noDeviceSelected"));
	                        } else {
	                            totpSelectDeviceForm.fadeOut(function () {
	                                var input = com.ts.mobile.sdk.TargetBasedAuthenticatorInput.createTargetsSelectionRequest(selectedTargets);
	                                resolve(com.ts.mobile.sdk.InputOrControlResponse.createInputResponse(input));
	                            });
	                        }
	                    });
	                    _this4.common.prependPageHeader(totpSelectDeviceForm, _this4.title, resolve);
	                });
	            };

	            TotpAuthenticatorSession.prototype.promiseCodeInput = function () {
	                var self = this;
	                return new Promise(function (resolve, reject) {
	                    if (self.challenge) {
	                        switch (self.challenge.getFormat().getType()) {
	                            case com.ts.mobile.sdk.TotpChallengeFormatType.Numeric:
	                            case com.ts.mobile.sdk.TotpChallengeFormatType.AlphaNumeric:
	                                console.log(self.challenge.getValue());
	                                break;
	                            case com.ts.mobile.sdk.TotpChallengeFormatType.QrCode:
	                                lpCoreBus.publish('user_payment_journey.uiHandler.showQRcode', self.challenge.getValue());
	                                break;
	                        }
	                    } else {
	                        //prompt = this.common.resolveString("totp.instructions");
	                    }

	                    var resolveSoftTokenPromise = {
	                        "resolve": resolve,
	                        "reject": reject
	                    };
	                    lpCoreBus.publish('user_hrp_journey.uiHandler.showTotp', resolveSoftTokenPromise);
	                });
	            };

	            TotpAuthenticatorSession.prototype.promiseRegInput = function () {
	                throw new Error("Method not implemented.");
	            };

	            return new TotpAuthenticatorSession(title, username, this.common);
	        };
	        CustomUIHandler.prototype.startActivityIndicator = function () {
	            console.log('<><><><>CAlled start UI indicator');
	        };
	        CustomUIHandler.prototype.endActivityIndicator = function () {
	            console.log('<><><><>CAlled end UI indicator');
	        };

	        CustomUIHandler.prototype.controlFlowStarting = function (clientContext) {
	            console.log('control flow starting');
	            console.log(clientContext);
	        };

	        CustomUIHandler.prototype.controlFlowActionStarting = function (clientContext) {
	            console.log('control flow action starting');
	            console.log(clientContext);
	        };

	        CustomUIHandler.prototype.controlFlowActionEnded = function (clientContext) {
	            console.log('control flow action ending');
	            console.log(clientContext);
	        };

	        CustomUIHandler.prototype.controlFlowEnded = function (clientContext) {
	            console.log('control flow ending');
	            console.log(clientContext);
	        };

	        function setJourney(journeyName, subJourney) {
	            //subJourney
	            journey = journeyName;
	            subModuleJourney = subJourney;
	        }
	        function resolvePromise(journey, requestObject) {
	            var formInput = com.ts.mobile.sdk.FormInput.createFormInputSubmissionRequest(requestObject);
	            promises[journey].resolve(formInput);
	        }
	        function rejectPromise(journey) {
	            promises[journey].reject(false);
	        }
	        function setKeyValue(obj, value) {
	            jsonData[obj] = value;
	        }

	        function resetJsonProviderData() {
	            jsonData = {};
	        }

	        function getKeyValue(obj) {
	            console.log(jsonData);
	            return jsonData[obj];
	        }

	        return {
	            CustomUIHandler: new CustomUIHandler(),
	            setJourney: setJourney,
	            getKeyValue: getKeyValue,
	            resolvePromise: resolvePromise,
	            rejectPromise: rejectPromise,
	            resetJsonProviderData: resetJsonProviderData
	        };
	    }

	    /**
	     * Exports
	     */
	    exports.metroUiHandler = metroUiHandler;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 14 */
/***/ (function(module, exports) {

	"use strict";

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TicketWaitSession = void 0;

	var TicketWaitSession = function () {
	  function TicketWaitSession(common) {
	    _classCallCheck(this, TicketWaitSession);

	    this.pollingIntervalMillis = 3000;
	    this.common = common;
	  }

	  _createClass(TicketWaitSession, [{
	    key: "setWaitingTicket",
	    value: function setWaitingTicket(ticketWaitInfo) {
	      this.ticketWaitInfo = ticketWaitInfo;

	      if (this.ui) {
	        this.loadTicketInfoToUi();
	      }
	    }
	  }, {
	    key: "startSession",
	    value: function startSession(actionContext, clientContext) {
	      console.log("------------TicketWaitSession--------------");
	      this.clientContext = clientContext;
	      this.common.setAriaBusy(this.clientContext);
	      this.ui = this.createUi();
	      this.loadTicketInfoToUi();
	      this.common.unsetAriaBusy(this.clientContext);
	      this.ui.fadeIn();
	    }
	  }, {
	    key: "endSession",
	    value: function endSession() {
	      this.common.clearContainer(this.clientContext);
	      this.ui = null;
	      this.abortPolling();
	    }
	  }, {
	    key: "promiseInput",
	    value: function promiseInput() {
	      var _this = this;

	      return new Promise(function (accept, reject) {
	        _this.currentInputPromiseResolver = function (input) {
	          _this.currentInputPromiseResolver = null;
	          return accept(input);
	        };

	        _this.startPolling();
	      });
	    }
	  }, {
	    key: "startPolling",
	    value: function startPolling() {
	      var _this2 = this;

	      this.pollingTimer = setTimeout(function () {
	        if (_this2.currentInputPromiseResolver) {
	          _this2.currentInputPromiseResolver(com.ts.mobile.sdk.InputOrControlResponse.createInputResponse(com.ts.mobile.sdk.TicketWaitInput.createPollRequest()));
	        }

	        _this2.pollingTimer = null;
	      }, this.pollingIntervalMillis);
	    }
	  }, {
	    key: "abortPolling",
	    value: function abortPolling() {
	      if (this.pollingTimer) {
	        clearTimeout(this.pollingTimer);
	        this.pollingTimer = null;
	      }
	    }
	  }, {
	    key: "createUi",
	    value: function createUi() {
	      var _this3 = this;

	      var uiContentBody = $('<div class="xmuiCore xmuiForm xmuiMobileAuthForm" style="display:none;">\
	                <div class="xmuiFullHeightContentBelowPrompt">\
	                    <div class="xmuiLoginInstructionsLabel"></div>\
	                    <div class="xmuiTicketText" style="display:none;"></div>\
	                    <div>\
	                        <img class="xmuiTicketImg" style="display:none;"/></img>\
	                    </div>\
	                    <div class="xmuiSpinner xmuiInProgress"></div>\
	                </div>\
	            </div>');
	      this.common.prependPageHeader(uiContentBody, "ticketWait", function (i) {
	        _this3.currentInputPromiseResolver(i);
	      });
	      this.common.appendElement(uiContentBody, this.clientContext);
	      return uiContentBody;
	    }
	  }, {
	    key: "loadTicketInfoToUi",
	    value: function loadTicketInfoToUi() {
	      if (this.ticketWaitInfo) {
	        if (this.ticketWaitInfo.getTicketId()) {
	          try {
	            switch (this.ticketWaitInfo.getTicketId().getFormat()) {
	              case com.ts.mobile.sdk.TicketIdFormat.Alphanumeric:
	                var text = this.ui.find(".xmuiTicketText");
	                text.text(this.ticketWaitInfo.getTicketId().getValue());
	                text.show();
	                break;

	              case com.ts.mobile.sdk.TicketIdFormat.Qr:
	                var img = this.ui.find(".xmuiTicketImg");
	                img.attr("src", "data:image/jpeg;base64," + this.ticketWaitInfo.getTicketId().getValue());
	                img.show();
	                break;

	              default:
	                this.common.log("Unsupported ticket ID format");
	                throw new Error("Unsupported ticket ID format");
	            }
	          } catch (e) {
	            this.common.log("Error in loadTicketInfoToUi(), not displaying ticket : " + e);
	          }
	        }

	        this.ui.find(".xmuiLoginInstructionsLabel").text(this.ticketWaitInfo.getText());
	        this.ui.find(".xmuiPageHeader span").text(this.ticketWaitInfo.getTitle());
	      }
	    }
	  }]);

	  return TicketWaitSession;
	}();

	exports.TicketWaitSession = TicketWaitSession;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';

	/* globals bd */
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports) {
	    'use strict';

	    // @ngInject

	    exports.metroContext = function () {

	        // @ngInject
	        /**
	         * @param {ng.IHttpService} $http
	         * @param {ng.ILogService} $log
	         * @param {ng.IQService} $q
	         */
	        this.$get = function ($http, $log, $q, lpCoreUtils) {

	            var config = {
	                userValidateEndpoint: lpCoreUtils.resolvePortalPlaceholders('$(servicesPath)/services/rest/users/$(userId)/validate/$(companyId)')
	            };

	            var cachedSession = null;

	            function getSession() {
	                if (!cachedSession) {
	                    cachedSession = JSON.parse(localStorage.getItem('session'));
	                }
	                return cachedSession;
	            }

	            function isValid(sess) {
	                return !bd.designMode || sess.status === 'VERIFIED';
	            }

	            function hasValidContext() {
	                var session = getSession();
	                if (session && isValid(session)) {
	                    return true;
	                }

	                $log.log('Cannot make request. Invalid context');
	                localStorage.removeItem('session');
	                return false;
	            }

	            function currentMBUserId() {
	                var session = getSession();

	                return session ? session.preferences.id : null;
	            }

	            function getPreferredName() {
	                var session = getSession();

	                return session ? session.preferences.preferredName : null;
	            }

	            function currentUserId() {
	                var session = getSession();

	                return session ? session.username : null;
	            }

	            function getCustomerId() {
	                var session = getSession();

	                return session ? session.customerId : null;
	            }

	            function currentCompany() {
	                // if opening new tab from a link
	                if (!sessionStorage.getItem('company')) {
	                    sessionStorage.setItem('company', localStorage.getItem('company'));
	                }

	                return hasValidContext() && sessionStorage.getItem('company') ? JSON.parse(sessionStorage.getItem('company')) : null;
	            }

	            function currentCompanyId() {
	                var company = currentCompany();
	                return company ? company.businessKey : null;
	            }

	            function userPrivileges() {
	                var company = currentCompany();
	                return company ? company.userPrivileges : null;
	            }

	            function hasEntitlement(entitlement) {
	                if (userPrivileges() && userPrivileges().entitlements && userPrivileges().entitlements[entitlement] == 'YES') {
	                    return true;
	                }
	                return false;
	            }

	            // Store entitlements in local storage to be accessible by all tabs
	            function setCompany(company) {
	                var deferred = $q.defer();
	                $http.get(config.userValidateEndpoint, {
	                    data: {
	                        userId: currentUserId(),
	                        companyId: company.businessKey
	                    }
	                }).success(function (response) {
	                    company.entitlements = response;
	                    company.userPrivileges = response.userPrivileges;
	                    sessionStorage.setItem('company', JSON.stringify(company));
	                    localStorage.setItem('company', JSON.stringify(company));
	                    sessionStorage.setItem('companyId', company.businessKey);
	                    deferred.resolve(company);
	                }).error(function (err) {
	                    deferred.reject(err.errorCode || 500);
	                });

	                return deferred.promise;
	            }

	            function actionKey(type) {
	                return currentCompanyId() + '-' + type;
	            }

	            function setAction(action) {
	                if (action.context.company) {
	                    setCompany(action.context.company).then(function () {
	                        localStorage.setItem(actionKey(action.type), JSON.stringify(action));
	                        if (action.redirectTo) {
	                            window.location.href = window.b$.portal.config.serverRoot + '/' + action.redirectTo;
	                        }
	                    });
	                } else {
	                    localStorage.setItem(actionKey(action.type), JSON.stringify(action));
	                    if (action.redirectTo) {
	                        window.location.href = window.b$.portal.config.serverRoot + '/' + action.redirectTo;
	                    }
	                }
	            }

	            /**
	             * Actions are specific per company
	             * @param type
	             */
	            function getAction(type) {
	                var key = actionKey(type);
	                var actionString = localStorage.getItem(key);

	                return actionString ? JSON.parse(actionString) : null;
	            }

	            /**
	             * Actions are specific per company
	             * @param type
	             */
	            function removeAction(type) {
	                var key = actionKey(type);
	                localStorage.removeItem(key);
	            }

	            function hasMultipleCompanies() {
	                var session = getSession();

	                return !!session && session.companies.data.length > 1;
	            }

	            function hasAnyApprovalLevel() {
	                var session = getSession();
	                if (!session) {
	                    return false;
	                }
	                var approvalLevels = session.approvalLevels;

	                for (var key in approvalLevels) {
	                    if (approvalLevels.hasOwnProperty(key) && approvalLevels[key] === 'AUTHORISE') {
	                        return true;
	                    }
	                }
	                return false;
	            }

	            function hasAnyVerificationLevel() {
	                var session = getSession();
	                if (!session) {
	                    return false;
	                }
	                var approvalLevels = session.approvalLevels;
	                for (var key in approvalLevels) {
	                    if (approvalLevels.hasOwnProperty(key) && approvalLevels[key] === 'VERIFY') {
	                        return true;
	                    }
	                }
	                return false;
	            }

	            return {
	                hasValidContext: hasValidContext,
	                currentCompanyId: currentCompanyId,
	                currentCompany: currentCompany,
	                currentUserId: currentUserId,
	                setCompany: setCompany,
	                setAction: setAction,
	                getAction: getAction,
	                removeAction: removeAction,
	                hasMultipleCompanies: hasMultipleCompanies,
	                getSession: getSession,
	                userPrivileges: userPrivileges,
	                hasEntitlement: hasEntitlement,
	                currentMBUserId: currentMBUserId,
	                getPreferredName: getPreferredName,
	                getCustomerId: getCustomerId,
	                hasAnyApprovalLevel: hasAnyApprovalLevel,
	                hasAnyVerificationLevel: hasAnyVerificationLevel
	            };
	        };
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';

	/* globals bd */

	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports) {
	    'use strict';

	    // @ngInject

	    exports.metroToggle = function () {

	        // @ngInject
	        /**
	         * @param {ng.IHttpService} $http
	         * @param {ng.ILogService} $log
	         * @param {ng.IQService} $q
	         */
	        this.$get = function ($http, lpCoreUtils, $q, metToggle) {

	            function setAllToggles(data) {
	                sessionStorage.setItem('Toggle', data);
	            }
	            function getStoredToggles() {
	                return sessionStorage.getItem('Toggle');
	            }
	            function getRequiredToggle(list, requiredToggle) {
	                var toggleList = new Array();
	                list = list.replace('{', '');
	                list = list.replace('}', '');
	                toggleList = list.split(",");
	                var value = {};
	                var val = 'false';
	                for (var i = 0; i < toggleList.length; i++) {
	                    value = toggleList[i].split(":");
	                    if (value[0] == '\"' + requiredToggle + '\"') {
	                        val = value[1];
	                    }
	                }
	                return val;
	            }
	            function getAllToggles() {
	                var deferred = $q.defer();
	                metToggle.api().getToggle().then(function (response) {
	                    deferred.resolve(response);
	                }).catch(function (error) {
	                    console.log('error');
	                    deferred.reject(response);
	                });
	                return deferred.promise;
	            }

	            return {
	                setAllToggles: setAllToggles,
	                getStoredToggles: getStoredToggles,
	                getAllToggles: getAllToggles,
	                getRequiredToggle: getRequiredToggle
	            };
	        };
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';

	/* globals bd */
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports) {
	    'use strict';

	    // @ngInject

	    exports.metroTagging = function () {

	        // @ngInject
	        /**
	         * @param {ng.IHttpService} $http
	         * @param {ng.ILogService} $log
	         * @param {ng.IQService} $q
	         */
	        this.$get = function ($http, $log, $q, lpCoreUtils, metroMeta, metroUtils, metroContext) {
	            var dataLayer = window.dataLayer = window.dataLayer || [];
	            var environmentSetting = metroUtils.findEnvironment();
	            var environmentAppType = metroMeta.ENVIRONMENT.APPTYPE.isWeb;
	            function onpageLoadTag(pageName, pagePath, event) {
	                var payload = {
	                    'environment': createEnvironment(),
	                    'page': createPage(pageName, pagePath),
	                    'event': event
	                };
	                dataLayer.push(payload);
	            }

	            function sweepsOnPageLoadTag(pageName, pagePath, event) {
	                var payload = {
	                    'environment': createEnvironment(),
	                    'page': createPage(pageName, pagePath),
	                    'event': event,
	                    'user': createUser()
	                };
	                dataLayer.push(payload);
	            }

	            function sweepsOnPageLoadEventTag(pageName, pagePath, eventName, eventAction, eventDetail, event) {
	                var payload = {
	                    'environment': createEnvironment(),
	                    'page': createPage(pageName, pagePath),
	                    'event': event,
	                    'user': createUser(),
	                    'attributes': createAttribute(eventName, eventAction, eventDetail)
	                };
	                dataLayer.push(payload);
	            }

	            function onpageLoadEventTag(pageName, pagePath, eventName, eventAction, eventDetail, event) {
	                var payload = {
	                    'environment': createEnvironment(environmentSetting, environmentAppType),
	                    'page': createPage(pageName, pagePath),
	                    'attributes': createAttribute(eventName, eventAction, eventDetail),
	                    'event': event
	                };
	                dataLayer.push(payload);
	            }
	            function onEventTag(eventName, eventAction, eventDetail, event) {
	                var payload = {
	                    'environment': createEnvironment(environmentSetting, environmentAppType),
	                    'attributes': createAttribute(eventName, eventAction, eventDetail),
	                    'event': event
	                };
	                dataLayer.push(payload);
	            }
	            function createAttribute(eventName, eventAction, eventDetail) {
	                var attributes = {
	                    'eventName': eventName,
	                    'eventAction': eventAction,
	                    'eventDetail': eventDetail
	                };
	                return attributes;
	            }
	            function createPage(pageName, pagePath) {
	                var page = {
	                    'pageUrl': metroMeta.PAGEURL.pageURL + pagePath,
	                    'pageName': pageName,
	                    'pagePath': pagePath
	                };
	                return page;
	            }

	            function createEnvironment() {
	                var timeoffset = new Date().getTimezoneOffset() * 60000;
	                var localISOTime = new Date(Date.now() - timeoffset).toISOString().slice(0, -1);

	                var environment = {
	                    'setting': environmentSetting,
	                    'appType': environmentAppType,
	                    'timeStamp': localISOTime
	                };
	                return environment;
	            }

	            function createUser() {
	                var user = {
	                    'authLevel': metroUtils.checkAuthLevel() === '0' ? '0' : '1/2'
	                };
	                return user;
	            }

	            return {
	                onpageLoadTag: onpageLoadTag,
	                onEventTag: onEventTag,
	                onpageLoadEventTag: onpageLoadEventTag,
	                sweepsOnPageLoadTag: sweepsOnPageLoadTag,
	                sweepsOnPageLoadEventTag: sweepsOnPageLoadEventTag
	            };
	        };
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';

	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports) {
	    'use strict';
	    // @ngInject

	    exports.metToggle = function () {

	        /**
	         * @param {ng.IQService} $q
	         * @param {ng.IHttpService} $http
	         */
	        // @ngInject
	        this.$get = function ($http, $q, lpCoreUtils, metroContext) {
	            var config = {
	                toggleEndpoint: lpCoreUtils.resolvePortalPlaceholders('$(servicesPath)/services/rest/toggle/all'),
	                sweepsEndpoint: lpCoreUtils.resolvePortalPlaceholders('$(servicesPath)/services/rest/sweeps/toggle/poc')
	            };

	            function API() {
	                var ToggleModel = function ToggleModel() {
	                    this.sweeps = '';
	                };
	                ToggleModel.prototype.getToggle = function () {
	                    var self = this;
	                    var deferred = $q.defer();

	                    self.loading = true;

	                    $http.get(config.toggleEndpoint, { data: {} }).success(function (data) {
	                        self.errorCode = null;

	                        deferred.resolve(data);
	                    }).error(function (data) {
	                        self.errorCode = data.errors[0].code || 500;
	                        deferred.reject(data);
	                    }).finally(function () {
	                        self.loading = false;
	                    });

	                    return deferred.promise;
	                };
	                ToggleModel.prototype.getSweeps = function () {
	                    var self = this;
	                    var deferred = $q.defer();

	                    self.loading = true;

	                    $http.get(config.sweepsEndpoint, { data: {} }).success(function (data) {
	                        self.errorCode = null;

	                        deferred.resolve(data);
	                    }).error(function (data) {
	                        self.errorCode = data.errors[0].code || 500;
	                        deferred.reject(data);
	                    }).finally(function () {
	                        self.loading = false;
	                    });

	                    return deferred.promise;
	                };
	                return new ToggleModel();
	            }

	            return {
	                setConfig: function setConfig(options) {
	                    config = lpCoreUtils(options).chain().mapValues(lpCoreUtils.resolvePortalPlaceholders).defaults(config).value();
	                    return this;
	                },

	                getConfig: function getConfig(prop) {
	                    if (prop && lpCoreUtils.isString(prop)) {
	                        return config[prop];
	                    }

	                    return config;
	                },

	                api: API
	            };
	        };
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';

	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports) {
	    'use strict';

	    exports.metroMeta = {
	        CONSTANTS_TRANSACTIONS: {
	            TRANSACTIONS: [{ label: 'Entered By', key: 'entered_by', sortable: false, colspan: null, show: 'showEnteredByColumn' }, { label: 'Payer Name', key: 'payer_name', sortable: false, colspan: null, show: 'showPayerNameColumn' }, { label: 'Payer Account No', key: 'payer_account_no', sortable: false, colspan: null, show: 'showPayerAccountColumn' }, { label: 'Payee Name', key: 'payee_name', sortable: false, colspan: null, show: 'showPayeeNameColumn' }, { label: 'Payee Account No', key: 'payee_account_no', sortable: false, colspan: null, show: 'showPayeeAccountColumn' }, { label: 'Payee Sort Code / BIC Code', key: 'payer_account_no', sortable: false, colspan: null, show: 'showSortCodeColumn' }, { label: 'Transaction Type', key: 'transaction_type', sortable: false, colspan: null, show: 'showTransactionTypeColumn' }, { label: 'Payment Date', key: 'payment_date', sortable: true, colspan: null, show: 'showPaymentDateColumn' }, { label: 'Debit Amount', key: 'debit_amount', sortable: false, colspan: 2, show: 'showDebitAmountColumn' }, { label: 'Credit Amount', key: 'credit_amount', sortable: false, colspan: 2, show: 'showCreditAmountColumn' }, { label: 'Status', key: 'status', sortable: false, colspan: null, show: 'showStatusColumn' }, { label: 'Reason', key: 'reason', sortable: false, colspan: null, show: 'showReasonColumn' }, { label: 'From Account', key: 'from_account', sortable: false, colspan: null, show: 'showFromAccount' }, { label: 'Frequency', key: 'frequency', sortable: false, colspan: null, show: 'showFrequency' }, { label: 'To Account', key: 'to_account', sortable: false, colspan: null, show: 'showToAcount' }, { label: 'Next Transfer Date', key: 'reason', sortable: false, colspan: null, show: 'showNextTransferDate' }, { label: 'Amount', key: 'Amount', sortable: false, colspan: 2, show: 'showAmount' }, { label: '', key: 'delete', sortable: false, colspan: null, show: 'showDeleteColumn' }],
	            PREFERENCES: ['showEnteredByColumn', 'showPayerNameColumn', 'showPayerAccountColumn', 'showPayeeNameColumn', 'showPayeeAccountColumn', 'showSortCodeColumn', 'showTransactionTypeColumn', 'showPaymentDateColumn', 'showDebitAmountColumn', 'showCreditAmountColumn', 'showStatusColumn', 'showReasonColumn', 'showFromAccount', 'showFrequency', 'showToAcount', 'showNextTransferDate', 'showAmount', 'maxNameCharsToDisplay', 'maxReasonCharsToDisplay']
	        },
	        MODAL: {
	            errorHandling: {
	                show: false,
	                success: {
	                    title: 'Success',
	                    showIcon: true,
	                    iconClasses: 'fa fa-check-circle fa-lg',
	                    iconColor: 'green',
	                    message: 'Your changes are being processed',
	                    messageType: 'success'
	                },
	                error: {
	                    title: 'Error',
	                    showIcon: true,
	                    iconClasses: 'fa fa-warning fa-lg',
	                    iconColor: 'red',
	                    message: 'Something went wrong',
	                    messageType: 'danger'
	                }
	            },
	            hardToken: {
	                show: false,
	                message: {
	                    title: 'Process',
	                    showIcon: false,
	                    message: 'Are you sure you want to continue with this update?',
	                    messageType: 'warning'
	                },
	                success: {
	                    title: 'Success',
	                    showIcon: true,
	                    iconClasses: 'fa fa-check-circle fa-lg',
	                    iconColor: 'green',
	                    message: 'Your changes are being processed',
	                    messageType: 'success'
	                },
	                error: {
	                    title: 'Error',
	                    showIcon: true,
	                    iconClasses: 'fa fa-warning fa-lg',
	                    iconColor: 'red',
	                    message: 'You have exceeded your number of hard token attempts. Please contact customer service on NNN-NNN-NNNN',
	                    messageType: 'danger'
	                }
	            }
	        },
	        SEARCH_TYPES: [{
	            name: 'Account Name',
	            value: 'accountName'
	        }, {
	            name: 'Account Number',
	            value: 'accountId'
	        }, {
	            name: 'Beneficiary Nickname',
	            value: 'beneficiaryName'
	        }],

	        SEARCH_TYPES2: [{
	            name: 'Account Name',
	            value: 'title'
	        }, {
	            name: 'Account Number',
	            value: 'businessKey'
	        }, {
	            name: 'Account Nickname',
	            value: 'nickname'
	        }],
	        SEARCH_TYPES3: [{
	            name: 'Beneficiary Name',
	            value: 'title'
	        }, {
	            name: 'Beneficiary Nickname',
	            value: 'nickname'
	        }, {
	            name: 'Account Number',
	            value: 'accountId'
	        }],
	        PROPERTYTRANSCATIONS_CODE_FOR_CHAPS: [{ id: 1, value: "HLRP", description: "Property Loan Repayment", key: "hlrp" }, { id: 2, value: "HLST", description: "Property Loan Settlement", key: "hlst" }, { id: 3, value: "PLDS", description: "Property Loan Disbursement", key: "plds" }, { id: 4, value: "PDEP", description: "Property Deposit", key: "pdep" }, { id: 5, value: "PCOM", description: "Property Completion Payment", key: "pcom" }, { id: 6, value: "PLRF", description: "Property Loan Refinancing", key: "plrf" }],
	        NOTIFICATIONS: {
	            VALID_HARD_TOKEN: {
	                notification: {
	                    id: '999',
	                    icon: 'lock',
	                    level: 'warning',
	                    closable: true,
	                    message: 'Enter a valid hard token. (this message is temporary until we have a generic hard token validation)'
	                }
	            },
	            NO_CANCELLED_DIRECT_DEBITS: {
	                level: 'warning',
	                icon: 'warning',
	                message: 'There are no cancelled direct debits'
	            },
	            NO_ACTIVE_DIRECT_DEBITS: {
	                level: 'warning',
	                icon: 'warning',
	                message: 'There are no active direct debits'
	            }
	        },
	        PAYMENT_TYPES: [{
	            name: 'Faster Payments',
	            value: 'FASTER_PAYMENTS',
	            tooltipKey: 'payment-type-faster-payments-description',
	            enabled: false,
	            allowScheduling: false
	        }, {
	            name: 'BACS',
	            value: 'BACS',
	            tooltipKey: 'payment-type-bacs-description',
	            enabled: false,
	            allowScheduling: true
	        }, {
	            name: 'CHAPS',
	            value: 'CHAPS',
	            tooltipKey: 'payment-type-chaps-description',
	            enabled: false,
	            allowScheduling: true
	        }, {
	            name: 'INTL',
	            value: 'INTL',
	            tooltipKey: 'payment-type-international-description',
	            enabled: false,
	            allowScheduling: true
	        }],
	        DOMESTIC_PAYMENT_TYPES: [{
	            name: 'Transfers',
	            value: 'TRANSFERS',
	            enabled: false,
	            allowScheduling: true,
	            tooltipKey: 'payment-type-transfer-description'
	        }, {
	            name: 'Metro Bank Payments',
	            value: 'MB_PAYMENTS',
	            enabled: false,
	            allowScheduling: false,
	            tooltipKey: 'payment-type-mb-payments-description'
	        }, {
	            name: 'Faster Payments',
	            value: 'FASTER_PAYMENTS',
	            enabled: false,
	            allowScheduling: false,
	            tooltipKey: 'payment-type-faster-payments-description'
	        }, {
	            name: 'BACS',
	            value: 'BACS',
	            enabled: false,
	            allowScheduling: false,
	            tooltipKey: 'payment-type-bacs-description'
	        }, {
	            name: 'CHAPS',
	            value: 'CHAPS',
	            enabled: false,
	            allowScheduling: false,
	            tooltipKey: 'payment-type-chaps-description'
	        }],
	        BATCH_PAYMENTS: [{
	            name: 'Faster Payments',
	            value: 'FASTER_PAYMENTS',
	            enabled: false,
	            allowScheduling: false,
	            tooltipKey: 'PAYMENT_TYPE_FASTER_PAYMENTS_DESCRIPTION',
	            reason: 'not enabled'
	        }, {
	            name: 'BACS',
	            value: 'BACS',
	            enabled: false,
	            allowScheduling: true,
	            tooltipKey: 'PAYMENT_TYPE_BACS_DESCRIPTION',
	            reason: 'not enabled'
	        }, {
	            name: 'CHAPS',
	            value: 'CHAPS',
	            enabled: false,
	            allowScheduling: false,
	            tooltipKey: 'PAYMENT_TYPE_CHAPS_DESCRIPTION',
	            reason: 'not enabled'
	        }],
	        MESSAGES: {
	            errorMessages: {
	                sortCode: 'Invalid sort code',
	                sortCodeTooShort: 'Invalid Sort Code. Are you missing a leading zero or a number?',
	                accountNumber: 'Invalid Account Number'
	            },

	            paymentReferenceMessages: {
	                maxlength: 'The reference entered is too long'
	            },

	            sortCodeErrorMessages: {
	                required: 'Please enter a sort code',
	                sortCode: 'Invalid sort code',
	                sortCodeTooShort: 'Invalid Sort Code. Are you missing a leading zero or a number?'
	            },

	            accountNumberMessages: {
	                required: 'Please enter an account number',
	                accountNumber: 'Invalid Account Number',
	                accountNumberLength: 'Account number must be 8 digits. Please check the account details and try again. If payee account number is shorter, please add zero(s) at the start of the number.',
	                accountNumberLengthExisting: 'To process payments successfully, account numbers now need to have 8 digits. This payee only has 7. Please delete it and re-enter their details, putting a zero at the very front of their account number. i.e. Account number 1234567 becomes 01234567'
	            },

	            beneficiaryNameErrorMessages: {
	                required: 'Please enter a payee name or select one from the address book'
	            },
	            noActivePaymentTypes: {
	                message: 'This payment type could be unavailable due to:',
	                noPermission: 'Insufficient access or mandate permissions',
	                noPaymentType: 'The beneficiary cannot receive the payment type',
	                paymentTypeUnavailable: 'The payment type being unavailable from your selected debit account'
	            }
	        },
	        STATUS: {
	            status: {
	                isFirstOpen: true,
	                isFirstDisabled: false
	            }
	        },
	        ENVIRONMENT: {
	            APPTYPE: {
	                isWeb: 'Web'
	            },
	            DEV: {
	                isDev: 'Dev'
	            },
	            STAGING: {
	                isStaging: 'Staging',
	                url: 'commercial-pp.metrobankonline.co.uk'
	            },
	            PROD: {
	                isProd: 'Prod',
	                url: 'commercial.metrobankonline.co.uk'
	            }
	        },
	        EVENT: {
	            buttonAction: 'buttonAction',
	            toggleAction: 'toggleAction',
	            pageLoaded: 'pageLoaded',
	            error: 'error',
	            radioAction: 'radioAction',
	            hoverAction: 'hoverAction',
	            goal: 'goals',
	            textentry: 'textEntry',
	            notification: 'notification'
	        },
	        PAGEURL: {
	            pageURL: 'https://commercial.metrobankonline.co.uk'
	        },
	        EVENTNAME: {
	            toggleSelect: 'toggleSelect',
	            buttonClick: 'buttonClick',
	            errorNotification: 'errorNotification',
	            radioSelect: 'radioSelect',
	            permissionNotification: 'permissionNotification',
	            goal: 'goals',
	            textentry: 'textEntry',
	            notification: 'notification'
	        },
	        EVENTACTION: {
	            createSweepReview: 'create sweep - review',
	            createSweepSuccess: 'create sweep - success',
	            createSweepError: 'create sweep - error',
	            deleteSweepReview: 'delete sweep - review',
	            deleteSweepSuccess: 'delete sweep - success',
	            sca: 'sca',
	            popup: 'pop up',
	            inline: 'inline'
	        },
	        LOGINPAGE: {
	            login: 'login',
	            loginUrl: '/business-login',
	            hardTokePage: 'Login - Hard Token Page | Metrobank',
	            seedsPage: 'Login - Seeds | Metrobank',
	            bindPopupPage: 'Login - Bind/UnBind Pop-up | Metrobank',
	            validateHardToken: 'login - validate hardtoken',
	            transmitValidate: 'login - validate via transmit',
	            loginValidate: 'login - validate',
	            bindPopup: 'login - bind/unbind popup',
	            validatePasswordSeed: 'login - validate password and seeds'
	        },
	        TRANSMIT: {
	            PAYMENT: {
	                FLOW: 'payment',
	                BENEFICIARY: 'beneficiary',
	                SINGLE_PAYMENT_NEW_PAYEE: 'single_payment_new_payee',
	                SINGLE_PAYMENT_EXISTING_PAYEE: 'single_payment_existing_payee',
	                BATCH_PAYMENT: 'batch_payment',
	                BULK_PAYMENT: 'bulk_payment',
	                OUTSTANDING_PAYMENTS_MANAGEMENT: 'outstanding_payments_management',
	                RECURRING_TRANSFERS: 'recurring_transfers',
	                STANDING_ORDER: 'standing_order',
	                BULK_BENEFICIARY: 'bulk_ben',
	                INTERNATIONAL: 'int',
	                DOMESTIC: 'dom',
	                BILLER: 'bil',
	                TRUSTED_BENEFICIARY: 'trusted_ben',
	                CREATE: 'create',
	                EDIT: 'edit',
	                AMEND: 'amend',
	                APPROVAL: 'approval'
	            },
	            HRP: {
	                FLOW: 'HRP',
	                USER: 'user',
	                ACCESS_GROUPS: 'access_groups',
	                ACCOUNT_GROUPS: 'account_groups',
	                CHANGE: 'change',
	                CREATE: 'create'
	            },
	            CARDS: {
	                JOURNEYWITHTRANACTIONLIST: 'authorise online payments',
	                JOURNEYSTARTEVENTDETAIL: 's1 - started',
	                JOURNEYCOMPLETEDDETAIL: 's1 - completed',
	                JOURNEYCOMPLETEDWITHRESULTDETAIL: 's3 - completed',
	                CONFIRMACTIONWITHAPPROVAL: 'authorise online payments: approval',
	                CONFIRMACTIONWITHCARDAPPROVAL: 'authorise your card: approval',
	                JOURNEYCUSSESSAPPROVAL: 'authorise online payments: approval',
	                CONFIRMACTIONWITHDECLINE: 'authorise online payments: decline',
	                JOURNEYCUSSESSWTHDECLINE: 'authorise online payments: decline',
	                APPROVEDPAYMENT: 'approved payment',
	                DECLINEDPAYMENT: 'declined payments',
	                APPROVEDCARD: 'approved card addition',
	                DECLINECARD: 'declined card addition'
	            },
	            SCA: {
	                CARDAPPROVALJOURNEYSTARTEVENTDETAIL: 's2 - started',
	                CARDAPPROVALJOURNEYCOMPLETEDDETAIL: 's2 - completed',
	                CARDJOURNEYSTARTEVENT: 'authorise online payments: approval',
	                PASSWORDTEXTENTRY: 'authenticating online payments: password',
	                DEVICEPASSCODETEXTENTRY: 'authenticating online payments: password'
	            }

	        }
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ })
/******/ ])
});
;


// WEBPACK FOOTER //
// scripts/main.js